import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_vue_table = _resolveComponent("vue-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, index) => {
      return (_openBlock(), _createBlock(_component_vue_table, _mergeProps({
        key: `section-table-${index}`
      }, section), _createSlots({ _: 2 }, [
        (index === 0)
          ? {
              name: "actions",
              fn: _withCtx(() => [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download()))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "download",
                    class: "icon pe-1"
                  }),
                  _createTextVNode(" Descargar cotización ")
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1040))
    }), 128))
  ]))
}